module.exports = __webpack_public_path__ + "static/media/18ECA52.5aba380f.jpg";